/* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { thousands, formatPercent } from 'react-wot-bootstrap/lib/helpers/format_number'

import { PRODUCT_TYPES } from './constants'

import styles from './containers/WGCWXShopDetailedProduct/WGCWXShopDetailedProduct.scss'

const getAmount = value => (
    <span className={styles.itemContent_amount}>
        {`x${value}`}
    </span>
)
const getStyleProductName = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style'
        defaultMessage='2D-стиль {name}'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductName907 = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.907'
        defaultMessage='3D-стиль {name} для Объектa 907'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameChiftein = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.chiftein'
        defaultMessage='3D-стиль {name} для T95/FV4201 Chieftain'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameNamenlos = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.namenlos'
        defaultMessage='3D-стиль {name} для VK 72.01 (K)'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameProserpina = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.proserpina'
        defaultMessage='3D-стиль {name} для Carro da Combattimento 45 t'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameHellraiser = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.hellraiser'
        defaultMessage='3D-стиль {name} для М60'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameKrait = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.krait'
        defaultMessage='3D-стиль {name} для 121В'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getStyleProductNameBasalt = name => (
    <FormattedMessage
        id='wgcwx_shop.products.style.basalt'
        defaultMessage='3D-стиль {name} для Объекта 907'
        values={{
            name: (
                <span className={styles.highlight}>
                    {name}
                </span>
            ),
        }}
    />
)
const getCrewBookProductName = experience => (
    <FormattedMessage
        id='wgcwx_shop.products.experience'
        defaultMessage='Учебное руководство на {experience}'
        values={{
            experience: (
                <span className={styles.highlight}>
                    {experience}
                </span>
            ),
        }}
    />
)
const PERSONAL_RESERVE_CONFIG = productType => product => {
    const reservesType = productType === PRODUCT_TYPES.PERSONAL_RESERVE_BIG ? (
        <FormattedMessage
            id='wgcwx_shop.products.personal_reserve_big.title'
            defaultMessage='пакет «Большой»'
        />
    ) : (
        <FormattedMessage
            id='wgcwx_shop.products.personal_reserve_small.title'
            defaultMessage='пакет «Малый»'
        />
    )

    const title = (
        <FormattedMessage
            id='wgcwx_shop.products.personal_reserve.title'
            defaultMessage='Личные резервы: {type}'
            values={{
                type: (
                    <span className={styles.highlight}>
                        {reservesType}
                    </span>
                ),
            }}
        />
    )

    const amount = getAmount(product.value)

    return {
        title,
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.personal_reserve.description'
                defaultMessage='Дают надбавки по результатам боев. Действуют определенное время.'
            />
        ),
        content: (
            <ul className={styles.itemContent_list}>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.personal_reserve.content.crew_bonus'
                        defaultMessage='{amount} {percent} к опыту экипажа на 1 час'
                        values={{ amount, percent: formatPercent(300) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.personal_reserve.content.free_xp_bonus'
                        defaultMessage='{amount} {percent} к свободному опыту на 1 час'
                        values={{ amount, percent: formatPercent(300) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.personal_reserve.content.battle_bonus'
                        defaultMessage='{amount} {percent} к боевому опыту на 1 час'
                        values={{ amount, percent: formatPercent(200) }}
                    />
                </li>
            </ul>
        ),
    }
}

export const PRODUCTS_SIZE_CONFIG = ['large', 'medium', 'small']

export const PRODUCTS_GRID_CONFIG = [
    ['KRAIT_STYLE', 'GRAPHITE_STYLE'],
    ['CREW_BOOK_NATIONAL', 'CREW_WOMAN'],
    ['WARRIOR_OF_THE_NORTH_STYLE', 'WARRIOR_OF_THE_SOUTH_STYLE'],
    ['WARRIOR_OF_THE_WEST_STYLE' , 'WARRIOR_OF_THE_EAST_STYLE'],
    ['PREMIUM_PLUS', 'SILVER', 'BONDS'],
    ['EXPERIENCE', 'FREE_XP_AND_CREW_XP' ],
]

export const PRODUCTS_GRID_CONFIG_CN = [
    ['KRAIT_STYLE', 'GRAPHITE_STYLE'],
    ['CREW_BOOK_NATIONAL', 'CREW_WOMAN'],
    ['WARRIOR_OF_THE_NORTH_STYLE', 'WARRIOR_OF_THE_SOUTH_STYLE'],
    ['WARRIOR_OF_THE_WEST_STYLE' , 'WARRIOR_OF_THE_EAST_STYLE'],
    ['PREMIUM_PLUS', 'SILVER', 'BONDS'],
    ['EXPERIENCE', 'FREE_XP_AND_CREW_XP' ],
]

export const PRODUCTS_CONFIG = {
    // TANK: all Tank card constants are defined in CardTank.jsx,
    [PRODUCT_TYPES.NAMENLOS_STYLE]: product => ({
        title: getStyleProductNameNamenlos(
            <FormattedMessage
                id='wgcwx_shop.products.namenlos_style.title'
                defaultMessage='«Наменлос»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.namenlos_style.description'
                defaultMessage='Всесезонный историчный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины VK 72.01 (K).'
            />
        ),
    }),
    [PRODUCT_TYPES.AIR_ELEMENTAL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.air_elemental_style.title'
                defaultMessage='«Элемент воздуха»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.air_elemental_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.EARTH_ELEMENTAL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.earth_elemental_style.title'
                defaultMessage='«Элемент земли»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.air_elemental_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.WATER_ELEMENTAL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.water_elemental_style.title'
                defaultMessage='«Элемент воды»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.air_elemental_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.FIRE_ELEMENTAL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.fire_elemental_style.title'
                defaultMessage='«Элемент огня»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.air_elemental_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.PROSERPINA_STYLE]: product => ({
        title: getStyleProductNameProserpina(
            <FormattedMessage
                id='wgcwx_shop.products.proserpina.title'
                defaultMessage='«Прозерпина»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.proserpina.description'
                defaultMessage='Всесезонный историчный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины Carro da Combattimento 45 t.'
            />
        ),
    }),
    [PRODUCT_TYPES.PFP_BATTLES]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.pfp_battles.title'
                defaultMessage='{bonus} к личным Очкам славы в боях'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                            {'+'}
                            <FormattedNumber value={product.value} />
                            {'%'}
                        </span>
                    ),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.bonds.pfp_battles.description'
                defaultMessage='Ускоряйте процесс получения личных Очков славы за участие в боях. Полученные бонусы суммируются.'
            />
        ),
    }),
    [PRODUCT_TYPES.GOLD]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.gold.title'
                defaultMessage='{bonus} золота'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                            <FormattedNumber value={product.value} />
                        </span>
                    ),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.gold.description'
                defaultMessage='Прекрасная возможность сделать игровой процесс комфортнее.'
            />
        ),
    }),
    [PRODUCT_TYPES.BONDS]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.bonds.title'
                defaultMessage='{bonus} бон'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                            <FormattedNumber value={product.value} />
                        </span>
                    ),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.bonds.description'
                defaultMessage='Это позволит покупать уникальные товары, недоступные за другую валюту.'
            />
        ),
    }),
    [PRODUCT_TYPES.SILVER]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.silver.title'
                defaultMessage='{bonus} кредитов'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                            {thousands(product.value)}
                        </span>
                    ),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.silver.description'
                defaultMessage='Это облегчит ваше продвижение по дереву исследований.'
            />
        ),
    }),
    [PRODUCT_TYPES.PREMIUM_PLUS]: product => {
        let title

        if (product.value === 1) title = (
            <FormattedMessage
                id='wgcwx_shop.products.premium_plus.title.1_day'
                defaultMessage='1 день танкового премиум аккаунта'
            />
        )

        if (product.value === 3) title = (
            <FormattedMessage
                id='wgcwx_shop.products.premium_plus.title.3_days'
                defaultMessage='3 дня танкового премиум аккаунта'
            />
        )

        if (product.value === 7) title = (
            <FormattedMessage
                id='wgcwx_shop.products.premium_plus.title.7_days'
                defaultMessage='7 дней танкового премиум аккаунта'
            />
        )

        return {
            title,
            description: (
                <FormattedMessage
                    id='wgcwx_shop.products.premium_plus.description'
                    defaultMessage='Это позволит получать дополнительные {percent} к кредитам и опыту.'
                    values={{ percent: formatPercent(50) }}
                />
            ),
        }
    },
    [PRODUCT_TYPES.PERSONAL_RESERVE_SMALL]: PERSONAL_RESERVE_CONFIG(PRODUCT_TYPES.PERSONAL_RESERVE_SMALL),
    [PRODUCT_TYPES.PERSONAL_RESERVE_BIG]: PERSONAL_RESERVE_CONFIG(PRODUCT_TYPES.PERSONAL_RESERVE_BIG),
    [PRODUCT_TYPES.DIGITAL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.digital_style.title'
                defaultMessage='«Клановый цифровой»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_style.description'
                defaultMessage='Стиль с индивидуальной раскраской для каждого из сезонов, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.VETERAN_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.veteran_style.title'
                defaultMessage='«Ветеран»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.veteran_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику X уровня.'
            />
        ),
    }),
    [PRODUCT_TYPES.GRAPHITE_STYLE]: product => ({
        title: getStyleProductName907(
            <FormattedMessage
                id='wgcwx_shop.products.graphite_style.title'
                defaultMessage='«Графит»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.graphite_style.description'
                defaultMessage='Всесезонный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины Объект 907.'
            />
        ),
    }),
    [PRODUCT_TYPES.CLAN_URBAN_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.clan_urban_style.title'
                defaultMessage='«Клановый городской»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.clan_urban_style.description'
                defaultMessage='Стиль с индивидуальной раскраской для каждого из сезонов, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.DIGITAL_ADAPTED_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.digital_adapted_style.title'
                defaultMessage='«Цифровой адаптированный»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_adapted_style.description'
                defaultMessage='Стиль с индивидуальной раскраской для каждого из сезонов, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.FIRE_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.fire_style.title'
                defaultMessage='«Пламень»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.fire_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.WARRIOR_OF_THE_EAST_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.east_warrior_style.title'
                defaultMessage='«Воин Востока»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.east_warrior_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.VANQUISHER_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.vanquisher_style.title'
                defaultMessage='«Покоритель»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.vanquisher_style.description'
                defaultMessage='Стиль с индивидуальной раскраской для каждого из сезонов, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.CONQUEROR_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.conqueror_style.title'
                defaultMessage='«Завоеватель»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.conqueror_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.NIGHTFALL_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.nightfall_style.title'
                defaultMessage='«Сумрак»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.nightfall_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.LIGHTNING_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.lightning_style.title'
                defaultMessage='«Молния»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.lightning_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику любого уровня.'
            />
        ),
    }),
    [PRODUCT_TYPES.CREW_BOOK_NATIONAL]: product => ({
        title: getCrewBookProductName(
            <FormattedMessage
                id='wgcwx_shop.products.crew_book_national.title'
                defaultMessage='{quantity} опыта'
                values={{
                    quantity: thousands(100000),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.crew_book_national.description'
                defaultMessage='Одноразовый предмет, применяется на выбранный экипаж. Прочтение даёт по 100 000 опыта каждому члену экипажа.'
            />
        ),
    }),
    [PRODUCT_TYPES.BROKEN_STONE_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.broken_stone_style.title'
                defaultMessage='«Колотый камень»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.broken_stone_style.description'
                defaultMessage='Стиль с индивидуальной раскраской для каждого из сезонов, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_WINTER]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_winter.title'
                defaultMessage='Зимний цифровой камуфляж'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_winter.description'
                defaultMessage='Зимний четырёхцветный «пиксельный» камуфляж. Вам будет начислено по 3 единицы камуфляжа для выбранной нации.'
            />
        ),
    }),
    [PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_SUMMER]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_summer.title'
                defaultMessage='Летний цифровой камуфляж'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_summer.description'
                defaultMessage='Летний четырёхцветный «пиксельный» камуфляж. Вам будет начислено по 3 единицы камуфляжа для выбранной нации.'
            />
        ),
    }),
    [PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_DESERT]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_desert.title'
                defaultMessage='Пустынный цифровой камуфляж'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.digital_camouflage_desert.description'
                defaultMessage='Пустынный четырёхцветный «пиксельный» камуфляж. Вам будет начислено по 3 единицы камуфляжа для выбранной нации.'
            />
        ),
    }),
    [PRODUCT_TYPES.GUARDIAN_OF_CROWN_STYLE]: product => ({
        title: getStyleProductNameChiftein(
            <FormattedMessage
                id='wgcwx_shop.products.guardian_of_crown_style.title'
                defaultMessage='«Страж Короны»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.guardian_of_crown_style.description'
                defaultMessage='Всесезонный историчный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины T95/FV4201 Chieftain.'
            />
        ),
    }),
    [PRODUCT_TYPES.HELLRAISER_STYLE]: product => ({
        title: getStyleProductNameHellraiser(
            <FormattedMessage
                id='wgcwx_shop.products.hellraiser_style.title'
                defaultMessage='«Хэлрейзер»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.hellraiser_style.description'
                defaultMessage='Всесезонный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины М60.'
            />
        ),
    }),
    [PRODUCT_TYPES.PROPHESY_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.prophesy_style.title'
                defaultMessage='«Предвестник»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.prophesy_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.JUDGEMENT_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.judgement_style.title'
                defaultMessage='«Воздаяние»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.judgement_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.REAPER_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.reaper_style.title'
                defaultMessage='«Жнец»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.reaper_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.EMBLEM]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.emblem.title'
                defaultMessage='Набор уникальных клановых эмблем'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.emblem.description'
                defaultMessage='Набор из пяти видов эмблем, ранее выдававшихся за события на Глобальной карте. Вам будет начислено 6 эмблем каждого вида.'
            />
        ),
    }),
    [PRODUCT_TYPES.CREW_WOMAN]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.crew_woman.title'
                defaultMessage='Девушка-танкист'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.crew_woman.description'
                defaultMessage='Девушки-танкисты уже имеют навык «Боевое братство». Можно выбрать нацию, тип техники и специальность, изученную сразу на {percent}.'
                values={{ percent: formatPercent(100) }}
            />
        ),
    }),
    [PRODUCT_TYPES.DIRECTIVES_PACK]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.directives_pack.title'
                defaultMessage='{amount} предбоевых инструкций'
                values={{
                    amount: (
                        <span className={styles.highlight}>
                            {`x${product.value * DIRECTIVES_TYPES_COUNT}`}
                        </span>
                    ),
                }}
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.directives_pack.description'
                defaultMessage='Предбоевые инструкции повышают эффективность оборудования и навыков/умений экипажа, что позволяет лучше раскрыть потенциал машины.'
            />
        ),
        content: (
            <ul className={styles.itemContent_list}>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.1'
                        defaultMessage='{amount} Повышенное внимание'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.2'
                        defaultMessage='{amount} Укрытия на местности'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.3'
                        defaultMessage='{amount} Искусство сбивать пламя'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.4'
                        defaultMessage='{amount} Продувка воздуховодов'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.5'
                        defaultMessage='{amount} Рациональная боеукладка'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack.content.6'
                        defaultMessage='{amount} Калибровка оптики'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
            </ul>
        ),
    }),
    [PRODUCT_TYPES.DIRECTIVES_PACK_30]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.directives_pack_30.title'
                defaultMessage='Предбоевые инструкции'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.directives_pack_30.description'
                defaultMessage='Предбоевые инструкции повышают эффективность оборудования и навыков/умений экипажа, что позволяет лучше раскрыть потенциал машины.'
            />
        ),
        content: (
            <ul className={styles.itemContent_list}>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack_30.content.4'
                        defaultMessage='{amount} Продувка воздуховодов'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack_30.content.5'
                        defaultMessage='{amount} Рациональная боеукладка'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id='wgcwx_shop.products.directives_pack_30.content.6'
                        defaultMessage='{amount} Калибровка оптики'
                        values={{ amount: getAmount(product.value) }}
                    />
                </li>
            </ul>
        ),
    }),
    [PRODUCT_TYPES.CREW_EXPERIENCE]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.crew_experience.title'
                defaultMessage='{bonus} к опыту экипажа на 1 ч'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                            {`+${formatPercent(300)}`}
                        </span>
                    ),
                }}
            />
        ),
    }),
    [PRODUCT_TYPES.FREE_EXPERIENCE]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.free_experience.title'
                defaultMessage='{bonus} к свободному опыту на 1 ч'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                           {`+${formatPercent(300)}`}
                        </span>
                    ),
                }}
            />
        ),
    }),
    [PRODUCT_TYPES.EXPERIENCE]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.expecience.title'
                defaultMessage='{bonus} к опыту на 1 ч'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                         {`+${formatPercent(50)}`}
                        </span>
                    ),
                }}
            />
        ),
    }),
    [PRODUCT_TYPES.WARRIOR_OF_THE_WEST_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.west_warrior_style.title'
                defaultMessage='«Воин Запада»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.west_warrior_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.WARRIOR_OF_THE_NORTH_STYLE]: product => ({
        title: getStyleProductName(
                <FormattedMessage
                    id='wgcwx_shop.products.north_warrior_style.title'
                    defaultMessage='«Воин Севера»'
                />
            ),
        description: (
                <FormattedMessage
                    id='wgcwx_shop.products.north_warrior_style.description'
                    defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
                />
            ),
    }),
    [PRODUCT_TYPES.WARRIOR_OF_THE_SOUTH_STYLE]: product => ({
        title: getStyleProductName(
            <FormattedMessage
                id='wgcwx_shop.products.south_warrior_style.title'
                defaultMessage='«Воин Юга»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.south_warrior_style.description'
                defaultMessage='Всесезонный стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Наносится на технику VIII–X уровней.'
            />
        ),
    }),
    [PRODUCT_TYPES.KRAIT_STYLE]: product => ({
        title: getStyleProductNameKrait(
            <FormattedMessage
                id='wgcwx_shop.products.krait_style.title'
                defaultMessage='«Крайт»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.krait_style.description'
                defaultMessage='Всесезонный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины 121B.'
            />
        ),
    }),
    [PRODUCT_TYPES.BASALT_STYLE]: product => ({
        title: getStyleProductNameBasalt(
            <FormattedMessage
                id='wgcwx_shop.products.basalt_style.title'
                defaultMessage='«Базальт»'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop.products.basalt_style.description'
                defaultMessage='Всесезонный 3D-стиль, выдаваемый игрокам за персональные и клановые достижения на Глобальной карте. Подходит только для машины Объект 907.'
            />
        ),
    }),
    [PRODUCT_TYPES.FREE_XP_AND_CREW_XP]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.free_xp_and_crew_xp.title'
                defaultMessage='{bonus} к свободному опыту и опыту экипажа на 1 ч'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                          {`+${formatPercent(200)}`}
                        </span>
                    ),
                }}
            />
        ),
        shortDetailedTitle: (
            <FormattedMessage
                id='wgcwx_shop.products.free_xp_and_crew_xp.short_title'
                defaultMessage='Личный резерв'
            />
        ),
    }),
    [PRODUCT_TYPES.XP_RESERVE]: product => ({
        title: (
            <FormattedMessage
                id='wgcwx_shop.products.xp_reserve.title'
                defaultMessage='{bonus} к опыту на 1 ч'
                values={{
                    bonus: (
                        <span className={styles.highlight}>
                           {`+${formatPercent(50)}`}
                        </span>
                    ),
                }}
            />
        ),
    }),
}

/**
 * number of types of items in directives pack,
 * should be adjusted manually with content of
 * ```PRODUCTS_CONFIG.DIRECTIVES_PACK(product).content```
 */
const DIRECTIVES_TYPES_COUNT = 6
export const NO_DESCRIPTION_VEHICLES = []



// WEBPACK FOOTER //
// ./containers/WGCWXShop/products.config.js